import script from "./detailModal.vue?vue&type=script&setup=true&lang=js"
export * from "./detailModal.vue?vue&type=script&setup=true&lang=js"

import "./detailModal.vue?vue&type=style&index=0&id=04e9a146&lang=less&scoped=true"

import exportComponent from "/home/opt/gitlab-runner/web_artemisads_repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-04e9a146"]])

export default __exports__